import {Country} from "@pg-rp/common-types";

import {Currency} from "../types/Currency";

export const getCurrency = (params: {country?: Country; currency?: Currency; ISOCodeFormat?: boolean}) => {
    if (params.currency) {
        return params.ISOCodeFormat ? getCurrencyISOCode(params.currency) : getCurrencyAbbreviation(params.currency);
    }

    switch (params.country) {
        // unknown currency, check country
        case Country.SPAIN:
            return params.ISOCodeFormat ? getCurrencyISOCode(Currency.EURO) : getCurrencyAbbreviation(Currency.EURO);
        case Country.POLAND:
        default:
            return params.ISOCodeFormat ? getCurrencyISOCode(Currency.PLN) : getCurrencyAbbreviation(Currency.PLN);
    }
};

const getCurrencyAbbreviation = (currency: Currency) => {
    switch (currency) {
        case Currency.EURO:
            return "eur";
        case Currency.PLN:
        default:
            return "zł";
    }
};

export const getCurrencyISOCode = (currency: Currency) => {
    switch (currency) {
        case Currency.EURO:
            return "EUR";
        case Currency.PLN:
        default:
            return "PLN";
    }
};
import {Country} from "@pg-rp/common-types";

import {Currency} from "../types/Currency";

export const getCurrency = (params: {country?: Country; currency?: Currency; ISOCodeFormat?: boolean}) => {
    if (params.currency) {
        return params.ISOCodeFormat ? getCurrencyISOCode(params.currency) : getCurrencyAbbreviation(params.currency);
    }

    switch (params.country) {
        // unknown currency, check country
        case Country.SPAIN:
            return params.ISOCodeFormat ? getCurrencyISOCode(Currency.EURO) : getCurrencyAbbreviation(Currency.EURO);
        case Country.POLAND:
        default:
            return params.ISOCodeFormat ? getCurrencyISOCode(Currency.PLN) : getCurrencyAbbreviation(Currency.PLN);
    }
};

const getCurrencyAbbreviation = (currency: Currency) => {
    switch (currency) {
        case Currency.EURO:
            return "eur";
        case Currency.PLN:
        default:
            return "zł";
    }
};

export const getCurrencyISOCode = (currency: Currency) => {
    switch (currency) {
        case Currency.EURO:
            return "EUR";
        case Currency.PLN:
        default:
            return "PLN";
    }
};
